'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { searchStateUtils } from '@/utils/searchStateUtils';

export function useSearchStateReset() {
  const pathname = usePathname();

  useEffect(() => {
    // Clear all search states when navigating to project list view
    if (pathname === '/project') {
      searchStateUtils.clearAllSearchStates();
    }
  }, [pathname]);
}